import * as orderState from './orderState';
import * as rfqState from './rfqState';

const TYPEMAP = {
  order: orderState,
  rfq: rfqState
};

function prependDeleteIfNeeded(record, availableStates) {
  const deleteOption =
    { key: 'delete', display: 'Delete', name: 'Deleted', default: false, mustConfirm: true };

  if (record.CanDelete) {
    availableStates.unshift(deleteOption);
  }
}

export function getAvailableStates(type, record) {
  if (record && TYPEMAP[type]) {
    const availableStates = TYPEMAP[type].getAvailableStates(record);
    prependDeleteIfNeeded(record, availableStates);

    return availableStates;
  }
  return [];
}

export function getCurrentState(type, record) {
  if (record && TYPEMAP[type]) {
    return TYPEMAP[type].getCurrentState(record);
  }
  return '';
}

export function changeState(state) {
  return (dispatch, getState) => {
    const type = getState().recordDetail.currentType;

    if (TYPEMAP[type]) {
      return dispatch(TYPEMAP[type].changeState(state));
    }
    return Promise.resolve();
  };
}



// WEBPACK FOOTER //
// ./src/recordDetail/states/states.js